module.exports = __webpack_public_path__ + "ea365f332bb0b8bb8f1fad69c2f4fcfc.svg";